const CLAVE = 'academy-tema';

/** Devuelve el tema guardado o, si no hay, el del sistema. */
export function temaInicial() {
  const guardado = localStorage.getItem(CLAVE);
  if (guardado === 'dark' || guardado === 'light') return guardado;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

/**
 * Se ejecuta en `main.jsx` ANTES del render para que la primera pantalla ya
 * salga con el tema correcto. Si se aplicara en un efecto, habría un parpadeo
 * de tema claro en cada recarga.
 */
export function aplicarTemaInicial() {
  const tema = temaInicial();
  document.documentElement.classList.toggle('dark', tema === 'dark');
  return tema;
}